import { z } from 'zod';
/** What caps the number of invalid rows an ingest may skip before it fails outright. */
export var FeedValidationSkipMethod;
(function (FeedValidationSkipMethod) {
    FeedValidationSkipMethod["NoMaximum"] = "NO_MAXIMUM";
    FeedValidationSkipMethod["ErrorRatio"] = "ERROR_RATIO";
    FeedValidationSkipMethod["ErrorRows"] = "ERROR_ROWS";
    FeedValidationSkipMethod["InheritFromAlert"] = "INHERIT_FROM_ALERT";
})(FeedValidationSkipMethod || (FeedValidationSkipMethod = {}));
export const FeedValidationSkipMethodSchema = z.enum(FeedValidationSkipMethod);
export var FeedAlertThresholdType;
(function (FeedAlertThresholdType) {
    FeedAlertThresholdType["Count"] = "Count";
    FeedAlertThresholdType["Ratio"] = "Ratio";
})(FeedAlertThresholdType || (FeedAlertThresholdType = {}));
export const FeedAlertThresholdTypeSchema = z.enum(FeedAlertThresholdType);
export const FeedValidationConfigSchema = z
    .object({
    skipInvalidRows: z.boolean().optional(),
    skipMethod: FeedValidationSkipMethodSchema.optional(),
    maxSkippableValidationErrorRatio: z.number().min(0).max(1).optional(),
    maxSkippableValidationErrorRows: z.number().min(0).max(Number.MAX_SAFE_INTEGER).optional(),
})
    .strict();
/** A ratio is a share of the rows and a count is a number of them, so the bound differs. */
export const FeedAlertThresholdSchema = z.discriminatedUnion('type', [
    z
        .object({
        type: z.literal(FeedAlertThresholdType.Ratio),
        value: z.number().min(0).max(1),
    })
        .strict(),
    z
        .object({
        type: z.literal(FeedAlertThresholdType.Count),
        value: z.number().min(0),
    })
        .strict(),
]);
/** An enabled alert has to say who to mail and when; a disabled one carries whatever it was left with. */
export const FeedAlertConfigSchema = z.discriminatedUnion('isEnabled', [
    z
        .object({
        isEnabled: z.literal(true),
        emails: z.array(z.email()).min(1),
        threshold: FeedAlertThresholdSchema,
    })
        .strict(),
    z
        .object({
        isEnabled: z.literal(false),
        emails: z.array(z.email()),
        threshold: z.looseObject({}).optional(),
    })
        .strict(),
]);
export const FeedProcessingConfigSchema = z
    .object({
    validation: FeedValidationConfigSchema.optional(),
    alerts: FeedAlertConfigSchema.optional(),
})
    .strict();
//# sourceMappingURL=processingConfig.js.map